import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const profiles = (rawClient, eventSource) => ({
    current: {
        read: allpeepNoPayloadEndpoint(rawClient, '/profiles/current'),
        update: allpeepPayloadEndpoint(rawClient, '/profiles/current', 'patch'),
        pinPost: allpeepPayloadEndpoint(rawClient, '/profiles/current/pinned-post', 'patch'),
        notifications: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications'),
        notificationStats: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications/stats'),
        notificationTypes: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications/types'),
        reposts: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/reposts'),
        bookmarkedIds: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/bookmarkedIds'),
        markAllNotificationsAsSeen: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/notifications/mark-all-seen', 'put'),
        readSettings: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/settings'),
        updateSettings: allpeepPayloadEndpoint(rawClient, '/profiles/current/settings', 'put'),
        accessTokens: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/access-tokens'),
        createAccessToken: allpeepPayloadEndpoint(rawClient, '/profiles/current/access-tokens', 'post'),
        revokeAccessToken: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/access-tokens/:accessTokenId', 'delete'),
        sessionEvents: {
            listen: eventSource('/profiles/current/session/events'),
        },
        blocked: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/blocked'),
        followedHashtags: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/hashtags'),
        followHashtag: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/hashtags/:tag/follow', 'post'),
        unfollowHashtag: allpeepNoPayloadEndpoint(rawClient, '/profiles/current/hashtags/:tag/follow', 'delete'),
    },
    list: allpeepNoPayloadEndpoint(rawClient, '/profiles'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id'),
    findByHandle: allpeepNoPayloadEndpoint(rawClient, '/profiles/by-handle/:handle'),
    follow: allpeepPayloadEndpoint(rawClient, '/profiles/:id/follow', 'post'),
    unfollow: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/follow', 'delete'),
    block: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/block', 'post'),
    unblock: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/block', 'delete'),
    followers: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/followers'),
    following: allpeepNoPayloadEndpoint(rawClient, '/profiles/:id/following'),
    commonGroups: allpeepNoPayloadEndpoint(rawClient, '/profiles/:profileId/common-groups'),
    activitySummary: allpeepNoPayloadEndpoint(rawClient, '/profiles/:profileId/activity-summary'),
});
